import React, { useState } from "react";
import $ from "jquery";

import { getComponentValue } from "../tab_options/settings/Config";

import BackgroundTab from "../tab_options/BackgroundTab";
import FavoriteTab from "../tab_options/FavoriteTab";
import SettingsTab from "../tab_options/SettingsTab";

export let popupOptionsShow = false;

export const changePopupOptions = () => {
	if (!popupOptionsShow) popupOptionsShow = true;
	else popupOptionsShow = false;
};

export const show = () => {
	$(".popup-options").css("display", "flex");
	$(".triangle").css("display", "block");
};

export const hidden = (e) => {
	e.stopPropagation();
	e.preventDefault();
	$(".popup-options").css("display", "none");
	$(".triangle").css("display", "none");
};

export const background = (e) => {
	if (popupOptionsShow) {
		hidden(e);
		changePopupOptions();
	}
};

function PopupOptions(props) {
	const [lang, setLang] = useState(getComponentValue("language"));
	const [favorites, setFavorites] = useState(null);
	const [backgrounds, setBackgrounds] = useState(null);

	function handleChangeLang(updatedLang) {
		setLang(updatedLang);
		props.onChangeLang(updatedLang);
	}

	function handleChangeSettings(updatedSettings) {
		props.onChangeSettings(updatedSettings);
	}

	function handleChangeFavorites(updatedFav) {
		props.onChangeFavorites(updatedFav);
		setFavorites(updatedFav);
	}

	function handleNewImportFavorites() {
		setFavorites(JSON.parse(localStorage.getItem("dataFavorite")));
		handleChangeFavorites(JSON.parse(localStorage.getItem("dataFavorite")));
	}

	function handleNewImportBackgrounds() {
		setBackgrounds({
			images: JSON.parse(localStorage.getItem("images")),
			imageName: localStorage.getItem("default-image-name"),
			defaultImage: localStorage.getItem("default-image"),
			option: localStorage.getItem("checkbox-option"),
		});
	}

	function changeTab(id) {
		if (id.startsWith("tab-name-")) {
			$(".tab-option.tab-option-active").removeClass("tab-option-active");
			$(`#${id}`).addClass("tab-option-active");
			$(".tab.tab-active").removeClass("tab-active");
			$(`#tab-${id.split("tab-name-").join("")}`).addClass("tab-active");
		}
	}

	return (
		<div className="popup-options">
			<div
				id="tab-name-background"
				className="tab-option tab-option-active"
				onClick={(e) => changeTab(e.target.id)}
			>
				{(lang === "es") ? "Fondos" : "Background"}
				<BackgroundTab lang={lang} backgrounds={backgrounds} />
			</div>
			<div
				id="tab-name-favorites"
				className="tab-option"
				onClick={(e) => changeTab(e.target.id)}
			>
				{(lang === "es") ? "Favoritos" : "Favorites"}
				<FavoriteTab lang={lang} onChange={handleChangeFavorites} favs={favorites} />
			</div>
			<div
				id="tab-name-settings"
				className="tab-option"
				onClick={(e) => changeTab(e.target.id)}
			>
				{(lang === "es") ? "Configuración" : "Settings"}
				<SettingsTab onChangeLang={handleChangeLang} onChange={handleChangeSettings} newImportFavorites={handleNewImportFavorites} newImportBackgrounds={handleNewImportBackgrounds} />
			</div>
		</div>
	);
}

export default PopupOptions;
